module.exports = __webpack_public_path__ + "img/luxall.ab23d58a.png";